import { render, staticRenderFns } from "./RoleAutocomplete.vue?vue&type=template&id=5c4017a6"
import script from "./RoleAutocomplete.vue?vue&type=script&lang=js"
export * from "./RoleAutocomplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports